export class UserModel {
    public UserName: string;
    public Email: string;
    public Role: string;
    public ApiToken: string;
    public ExpireAt: Date;
    public UserInfoId: string;
    public FirstName: string;
    public LastName: string;
    public PhoneNumber: string;
    public UserId: string;
  }
  